import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background-100 px-4 text-center">
      <span className="flex h-16 w-16 items-center justify-center rounded-full bg-primary-100 text-primary-600">
        <i className="ri-compass-3-line text-3xl"></i>
      </span>
      <h1 className="mt-6 font-heading text-3xl font-bold text-foreground-950">页面不存在</h1>
      <p className="mt-2 text-sm text-foreground-500">
        你访问的页面可能已被移除，或链接输入有误。
      </p>
      <Link
        to="/admin"
        className="mt-7 inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
      >
        <i className="ri-arrow-left-line"></i>
        返回管理后台
      </Link>
    </div>
  );
}